import DeleteOutline from '@mui/icons-material/DeleteOutline'
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Tooltip,
} from '@mui/material'
import type { TemplateHint } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { updateTemplateNode } from 'src/state/ducks/templates/actions'
import { deleteTemplateHint } from 'src/state/ducks/templates/templateHints/actions'
import type { RootState } from 'src/state/store'

const HintAction: FC<{
  hint: TemplateHint
}> = ({ hint }) => {
  const [open, setOpen] = useState(false)

  const templateNodes = useSelector(
    (state: RootState) => state.templatesState.templatePages.templateNodes,
    shallowEqual,
  )

  const dispatch = useDispatch()

  const handleConfirm = () => {
    const targetHintId = hint.id ?? ''

    // NOTE: すべてのノードのquestion.hints.blockを空にする
    for (const key of Object.keys(templateNodes)) {
      const thisNode = templateNodes[Number(key)]

      // 単に型の都合であり、実際にはundefinedになることはない想定
      if (thisNode?.id === undefined) continue

      const thisNodeHints = thisNode?.question?.hints ?? []
      if (thisNodeHints.length === 0) continue

      const nonTargetHints = thisNodeHints.filter(
        hint => hint.hintId !== targetHintId,
      )

      // 未調査: 空とはいえ、あえて削除したヒントを追加する必要があるだろうか？
      const emptiedTargetHint = {
        hintId: targetHintId,
        blocks: [],
      }

      dispatch(
        // ひな形からヒントを削除する
        updateTemplateNode(thisNode.id, {
          ...thisNode,
          question: {
            ...thisNode?.question,
            hints: [...nonTargetHints, emptiedTargetHint],
          },
        }),
      )
    }

    dispatch(deleteTemplateHint(targetHintId))
    setOpen(false)
  }

  return (
    <>
      <Tooltip title="ヒントを削除">
        <IconButton
          color="error"
          onClick={() => setOpen(true)}
          aria-label="ヒントを削除"
        >
          <DeleteOutline color="error" />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-label="ヒントを削除してもよろしいですか？"
      >
        <DialogTitle>ヒントを削除してもよろしいですか？</DialogTitle>
        <DialogActions>
          <Button variant="outlined" onClick={() => setOpen(false)}>
            キャンセル
          </Button>
          <Button variant="contained" color="error" onClick={handleConfirm}>
            削除
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default HintAction
